"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsManager = void 0;
class SettingsManager {
    async init(providers) {
        this.providers = providers;
        return this;
    }
    async get(settingName, defaultValue) {
        const providers = this.providers;
        for (const provider of providers) {
            const value = await provider.get(settingName, defaultValue);
            if (value !== undefined) {
                return value;
            }
        }
        return defaultValue;
    }
}
exports.SettingsManager = SettingsManager;
